/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  const selectors = {
    productForm: 'form[data-product-form]',
    giftWrapper: '[data-gift-box-wrapper]',
    giftCheckbox: '[data-gift-box-checkbox]',
    giftQuantity: '[data-gift-box-quantity]',
    giftVariantId: '[data-gift-box-variant-id]',
    parentTitle: '[data-gift-box-parent-title]',
    variantId: '[name="id"]',
    quantity: '[name="quantity"]',
    errors: '[data-cart-errors-container]',
    addToCart: '[data-add-to-cart]',
  };

  function toInt(value, fallback) {
    const parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function getGiftElements(form) {
    const wrapper = form.querySelector(selectors.giftWrapper);
    if (!wrapper) return null;

    const checkbox = wrapper.querySelector(selectors.giftCheckbox);
    const giftQtyInput = wrapper.querySelector(selectors.giftQuantity);
    const giftVariantInput = wrapper.querySelector(selectors.giftVariantId);
    const parentTitleInput = wrapper.querySelector(selectors.parentTitle);
    const mainQtyInput = form.querySelector(selectors.quantity);
    const mainVariantInput = form.querySelector(selectors.variantId);

    if (!checkbox || !giftQtyInput || !giftVariantInput || !mainVariantInput) return null;

    return {
      checkbox,
      giftQtyInput,
      giftVariantInput,
      parentTitleInput,
      mainQtyInput,
      mainVariantInput,
    };
  }

  function getMainQuantity(mainQtyInput) {
    return Math.max(1, toInt(mainQtyInput?.value, 1));
  }

  function syncGiftQuantity(form) {
    const els = getGiftElements(form);
    if (!els) return;

    const mainQty = getMainQuantity(els.mainQtyInput);
    const currentGiftQty = Math.max(1, toInt(els.giftQtyInput.value, 1));
    const clampedQty = Math.min(currentGiftQty, mainQty);

    els.giftQtyInput.max = String(mainQty);
    els.giftQtyInput.value = String(clampedQty);
    els.giftQtyInput.disabled = !els.checkbox.checked;
  }

  function showError(form, message) {
    const errorContainer = form.closest('product-form')?.querySelector(selectors.errors) || form.querySelector(selectors.errors);
    if (!errorContainer) return;

    errorContainer.innerHTML = '<div class="errors">' + message + '</div>';
    errorContainer.classList.add('is-visible');
  }

  function clearError(form) {
    const errorContainer = form.closest('product-form')?.querySelector(selectors.errors) || form.querySelector(selectors.errors);
    if (!errorContainer) return;
    errorContainer.classList.remove('is-visible');
  }

  document.addEventListener('change', function(event) {
    const form = event.target.closest(selectors.productForm);
    if (!form) return;
    if (!form.querySelector(selectors.giftWrapper)) return;
    syncGiftQuantity(form);
  });

  document.addEventListener('input', function(event) {
    const form = event.target.closest(selectors.productForm);
    if (!form) return;
    if (!form.querySelector(selectors.giftWrapper)) return;
    if (event.target.matches(selectors.quantity) || event.target.matches(selectors.giftQuantity)) {
      syncGiftQuantity(form);
    }
  });

  document.addEventListener(
    'submit',
    function(event) {
      const form = event.target.closest(selectors.productForm);
      if (!form) return;

      const giftEls = getGiftElements(form);
      if (!giftEls || !giftEls.checkbox.checked) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      clearError(form);
      syncGiftQuantity(form);

      const mainVariantId = giftEls.mainVariantInput.value;
      const giftVariantId = giftEls.giftVariantInput.value;
      const mainQty = getMainQuantity(giftEls.mainQtyInput);
      const giftQty = Math.max(1, toInt(giftEls.giftQtyInput.value, 1));

      if (!giftVariantId) {
        showError(form, 'No hay caja de regalo configurada para este producto.');
        return;
      }

      if (giftQty > mainQty) {
        showError(form, 'La cantidad de cajas de regalo no puede ser mayor que la cantidad del producto.');
        return;
      }

      const submitButton = form.closest('product-form')?.querySelector(selectors.addToCart) || form.querySelector(selectors.addToCart);
      if (submitButton) {
        submitButton.classList.add('is-loading');
        submitButton.disabled = true;
      }

      const payload = new FormData();
      const packId = 'pack_' + Date.now() + '_' + Math.floor(Math.random() * 1000000);
      payload.append('items[0][id]', mainVariantId);
      payload.append('items[0][quantity]', String(mainQty));
      payload.append('items[0][properties][_PackId]', packId);
      payload.append('items[0][properties][_PackRole]', 'main');

      const sellingPlan = form.querySelector('[name="selling_plan"]');
      if (sellingPlan && sellingPlan.value) {
        payload.append('items[0][selling_plan]', sellingPlan.value);
      }

      form.querySelectorAll('[name^="properties["]').forEach((input) => {
        if (input.disabled || !input.name) return;
        payload.append('items[0][' + input.name + ']', input.value || '');
      });

      payload.append('items[1][id]', giftVariantId);
      payload.append('items[1][quantity]', String(giftQty));
      payload.append('items[1][properties][_PackId]', packId);
      payload.append('items[1][properties][_PackRole]', 'gift');
      payload.append('items[1][properties][_Caja regalo para]', giftEls.parentTitleInput?.value || '');
      payload.append('items[1][properties][_Producto principal variant id]', mainVariantId);

      fetch(window.theme.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript',
        },
        body: payload,
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            const errorText = response.description || response.message || 'No se pudo agregar al carrito.';
            showError(form, errorText);
            if (submitButton) {
              submitButton.classList.remove('is-loading');
              submitButton.disabled = false;
            }
            return;
          }

          if (submitButton) {
            submitButton.dispatchEvent(
              new CustomEvent('theme:product:add', {
                detail: {
                  response: response,
                  button: submitButton,
                },
                bubbles: true,
              })
            );
          }

          if (window.theme.settings.cartType === 'page') {
            window.location = window.theme.routes.cart_url;
            return;
          }

          document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
        })
        .catch(() => {
          showError(form, 'No se pudo agregar al carrito. Intenta nuevamente.');
          if (submitButton) {
            submitButton.classList.remove('is-loading');
            submitButton.disabled = false;
          }
        });
    },
    true
  );

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll(selectors.productForm).forEach((form) => {
      if (form.querySelector(selectors.giftWrapper)) {
        syncGiftQuantity(form);
      }
    });
  });

  function getPackInfoForKey(cart, itemKey) {
    const currentItem = cart.items.find((item) => item.key === itemKey);
    if (!currentItem || !currentItem.properties || !currentItem.properties._PackId) return null;

    const packId = currentItem.properties._PackId;
    const packItems = cart.items.filter((item) => item.properties && item.properties._PackId === packId);
    if (!packItems.length) return null;

    return {
      packId: packId,
      currentItem: currentItem,
      packItems: packItems,
      mainItem: packItems.find((item) => item.properties && item.properties._PackRole === 'main') || packItems[0],
      giftItem: packItems.find((item) => item.properties && item.properties._PackRole === 'gift') || null,
    };
  }

  function syncPackUpdate(itemKey, requestedQty) {
    return fetch(window.theme.routes.cart_url + '.js')
      .then((response) => response.json())
      .then((cart) => {
        const packInfo = getPackInfoForKey(cart, itemKey);
        if (!packInfo) return null;

        const qty = Math.max(0, toInt(requestedQty, 0));
        const updates = {};
        const currentRole = packInfo.currentItem.properties?._PackRole || '';

        if (qty === 0) {
          packInfo.packItems.forEach((item) => {
            updates[item.key] = 0;
          });
        } else {
          const mainQty = currentRole === 'gift' ? packInfo.mainItem.quantity : qty;
          const giftQtyBase = packInfo.giftItem ? packInfo.giftItem.quantity : 0;
          const giftQty = Math.min(giftQtyBase, mainQty);

          updates[packInfo.mainItem.key] = mainQty;
          if (packInfo.giftItem) {
            updates[packInfo.giftItem.key] = giftQty;
          }
        }

        return fetch(window.theme.routes.cart_update_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({updates: updates}),
        }).then(() => {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
          return true;
        });
      })
      .catch(() => null);
  }

  document.addEventListener(
    'click',
    function(event) {
      const removeLink = event.target.closest('[data-item-remove]');
      if (!removeLink) return;
      const item = removeLink.closest('[data-item]');
      const packId = item?.dataset?.packId;
      if (!packId) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      syncPackUpdate(removeLink.dataset.id, 0);
    },
    true
  );

  document.addEventListener(
    'theme:cart:update',
    function(event) {
      const item = event.target.closest('[data-item]');
      const packId = item?.dataset?.packId;
      if (!packId) return;

      event.stopImmediatePropagation();
      const qty = event.detail?.quantity;
      const key = event.detail?.id;
      syncPackUpdate(key, qty);
    },
    true
  );
  document.addEventListener('change', function(e) {
  if (e.target.name === 'updates[]') {
    
    const row = e.target.closest('[data-cart-item]');
    if (!row) return;

    const title = row.innerText || '';

    if (title.includes('suscripcion-puelo-empresas')) {
      if (parseInt(e.target.value) < 2) {
        e.target.value = 2;
      }
    }
  }
});







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

class PivotVentiSubscription extends HTMLElement {
  constructor() {
    super();
    this.$frequency = this.querySelector('.pivot-venti-frecuency');
  }
  connectedCallback() {
    if (!this.isConnected) return;
    this.addEventListener('change', () => this.selection());
    this.selection();
  }
  selection() {
    const selected = this.querySelector('input[name="buy_type"]:checked');
    if (this.$frequency) {
      this.$frequency.disabled = selected?.value !== 'subscription';
    }
  }
}
if (!customElements.get('pivot-venti-subsctiption')) {
  customElements.define('pivot-venti-subsctiption', PivotVentiSubscription);
}
